import { defineStore } from 'pinia'

interface UserInfo {
	name: string
	email?: string
	avatar?: string
	[key: string]: any
}

interface State {
	userInfo: UserInfo | null
	token: string | null
}

export const useUserStore = defineStore('user', {
	state: (): State => ({
		userInfo: null,
		token: null,
	}),
	getters: {
		getUserInfo: state => state.userInfo,
		getToken: state => state.token,
	},
	actions: {
		setUserInfo(userInfo: UserInfo | null) {
			this.userInfo = userInfo
		},
		setToken(token: string) {
			this.token = token
		},
		removeUserInfo() {
			this.userInfo = null
		},
		removeToken() {
			this.token = null
		},
		removeAll() {
			this.userInfo = null
			this.token = null
		},
	},
	persist: [
		{
			key: `student_persist_${import.meta.env.MODE}_user`,
			storage: localStorage,
		},
	],
})
